var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg58 = function Svg58(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8V7h1v1h1V6h-1V5h-1V4h-1V2h-1V1H9V0H3v1H2v1H1v2H0v5h1v1h1v2h1v1h1v1h2v-2H5v-1h1v1h1v1h1v1h2v-1h1v-2h-1v-1h1v1h1v1h2V9h-1V8h-1ZM4 8v1H3V7h1V6h2v1h1v2H5V8H4Zm2-3V3h2v3H7V5H6ZM2 3h2v2H3v1H2V3Z",
    fill: "currentColor"
  })));
};
export default Svg58;